// prettier-ignore
import { 
  Component, ElementRef, ViewChild, Input, OnInit, Output, EventEmitter, 
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Comments } from '@usimweb/core/models';
import { ApiService } from '@usimweb/core/services';

import { Chat } from './chat';
import { Observable } from 'rxjs';
import { ChatService } from '@usimweb/core/services';

export enum CommentType {
  NEW = 'new',
  CURRENT = 'current',
}

interface IAnnotationManagerService {
  handleManualAnnotation(index: string): Observable<any>;
  removeAllAnnotations(index: string): void;
  setManualAnnotation(isAnnoHighlighter: boolean, index: string): void;
  showManualAnnotations(index: string, comment: Comments, selectedAnnotation: any): void;
  removeAnnotation(annotationIndex: string, index: string): void;
}

interface IScalarManagerService {
  getActiveScalar(index: string): string;
}

interface IDialogService {
  openTextDialog(component: any, data: any, title: string, saveBtn?: string, text?: string): Observable<any>;
  getDialog(dialog: string): any;
}

@Component({
    selector: 'usimweb-molded-chat',
    // changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './generic-chat.component.html',
    styleUrls: ['./generic-chat.component.scss'],
    standalone: false
})
export class MoldedChatComponent extends Chat implements OnInit, OnChanges {
  @ViewChild('chatMessages') chatMessages!: ElementRef;

  @Input() index!: string;

  @Input() version!: any;

  @Input() annotationManager!: IAnnotationManagerService;

  @Input() scalarManagerService!: IScalarManagerService;

  @Input() dialogService!: IDialogService;

  @Output() loadVersion: EventEmitter<any> = new EventEmitter<any>();

  public selectedAnno = 0;

  get active_scalar() {
    return this.scalarManagerService.getActiveScalar(this.index);
  }

  private isAnnoHighlighter: boolean = false;
  private commentType: CommentType = CommentType.NEW;

  constructor(apiService: ApiService, private snackBar: MatSnackBar, private chatService: ChatService) {
    super(apiService, snackBar);
    this.scrollToBottom();
  }

  ngOnInit(): void {
    this.isAnnotationMode = true;
    this.initProps(this.version, this.dialogService);
    this.initListeners();
    this.getComments();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.version && changes['version']) {
      this.updateVersion(this.version);
    }
  }

  private initListeners() {
    this.annotationManager.handleManualAnnotation(this.index).subscribe((annotations: any) => {
      if (this.commentType === CommentType.NEW) {
        this.currentAnnos = annotations;
        this.selectedAnnotation = annotations.length - 1;
      }

      if (this.commentType === CommentType.CURRENT) {
        const meta = this.comments[this.selectedAnnotation].meta;
        if (meta?.annotations) {
          meta.annotations = annotations;
        }
      }
      //this.cd.detectChanges();
    });
    this.loadVersionListener.subscribe((obj) => {
      if (obj) {
        this.loadVersion.emit(obj);
      }
    });

    this.resetValues.subscribe((reset) => {
      if (reset) {
        this.resetCurrentAnnos();
      }
    });

    this.chatService.resetAnnotationsListener().subscribe((reset) => {
      if (reset) {
        this.resetCurrentAnnos();
      }
    });
  }

  private scrollToBottom() {
    setTimeout(() => {
      this.chatMessages.nativeElement.scrollTop = this.chatMessages.nativeElement.scrollHeight;
    }, 1000);
  }

  private resetCurrentAnnos() {
    this.resetAnnoHighlighter();
    this.annotationManager.removeAllAnnotations(this.index);
    this.currentAnnos = [];
  }

  public override enablePicker(event: MouseEvent, commentType: CommentType, annotationindex: number) {
    if (this.activeComment) {
      this.resetValues.next(true);
      this.activeComment = false;
    }

    event.stopPropagation();
    this.commentType = commentType;
    this.selectedAnnotation = annotationindex;

    this.isAnnoHighlighter = !this.isAnnoHighlighter;
    this.annotationManager.setManualAnnotation(this.isAnnoHighlighter, this.index);
    this.snackBar.open('Toggled annotation picker...', 'OK', { duration: 2000 });
  }

  public selectAnnotation(event: MouseEvent, chunkIndex: number, comment?: Comments) {
    event.stopPropagation();
    this.resetAnnoHighlighter();
    this.selectedAnnotation = chunkIndex;

    if (comment) {
      this.annotationManager.showManualAnnotations(this.index, comment, this.selectedAnnotation);

      if (comment.meta?.annotations) {
        comment.meta.annotations.forEach((annotation, index) => {
          if (index === chunkIndex) {
            annotation.selected = true;
          } else {
            annotation.selected = false;
          }
        });
      }

      //this.cd.detectChanges();
    }

    if (!comment) {
      this.currentAnnos.forEach((annotation, index) => {
        annotation.selected = index === index;
      });
    }

    //this.cd.detectChanges();
  }

  public override comment(): void {
    this.resetAnnoHighlighter();
    this.addComment(this.active_scalar);
    this.scrollToBottom();
  }

  public resetAnnoHighlighter() {
    this.isAnnoHighlighter = false;
    this.annotationManager.setManualAnnotation(false, this.index);
  }

  public deleteAnnotation(annotationIndex: number, currentComment?: Comments) {
    this.dialogService
      .openTextDialog(this.dialogService.getDialog('InfoDialogComponent'), {}, 'Delete annotation', 'Delete', 'Are you sure you want to delete?')
      .subscribe((data: any) => {
        if (data) {
          if (currentComment) {
            if (currentComment.meta?.annotations) {
              currentComment.meta.annotations = currentComment.meta.annotations.filter((x, i) => i !== annotationIndex);
              this.annotationManager.removeAllAnnotations(this.index);
              //this.cd.detectChanges();
            }
          }
          if (!currentComment) {
            this.currentAnnos = this.currentAnnos.filter((x, i) => i !== annotationIndex);
            this.annotationManager.removeAnnotation(annotationIndex.toString(), this.index);
          }

          this.resetAnnoHighlighter();
          this.snackBar.open('Removed annotation...', 'OK', { duration: 2000 });
        }
      });

    return false;
  }
}
